<template>
  <v-app>
    <v-snackbar
      v-model="updateAvailable"
      :timeout="-1"
      bottom
      color="primary"
    >
      A new version is available.
      <template #action="{ attrs }">
        <v-btn text v-bind="attrs" @click="refreshApp">Update</v-btn>
      </template>
    </v-snackbar>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',

  data: () => ({
    updateAvailable: false,
    registration: null,
  }),

  created() {
    document.addEventListener('swUpdated', this.onSwUpdated, { once: true });
  },

  beforeDestroy() {
    document.removeEventListener('swUpdated', this.onSwUpdated);
  },

  methods: {
    onSwUpdated(event) {
      this.registration = event.detail;
      this.updateAvailable = true;
    },
    refreshApp() {
      this.updateAvailable = false;
      if (this.registration && this.registration.waiting) {
        this.registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
      window.location.reload();
    },
  },
};
</script>
